/* unplugin-vue-components disabled */import script from "./ClinicContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ClinicContent.vue?vue&type=script&setup=true&lang=js"

import "./ClinicContent.vue?vue&type=style&index=0&id=5f933682&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f933682"]])

export default __exports__